/** An answer counts only when it selects an option or holds non-blank text. */
export function hasAnswerContent(text, selectedOptionCount) {
    return selectedOptionCount > 0 || (text ?? '').trim().length > 0;
}
//# sourceMappingURL=answers.js.map